module.exports = __webpack_public_path__ + "static/garage-2626bca2469d75461d7cd09fb8eb1d9a.png";